/** The existing public bucket's cached custom domain. No bucket/config changes. */
export const PUBLIC_ASSET_ORIGIN = "https://driveshare-assets.com";
const DEVELOPMENT_ORIGIN = /https?:\/\/(?:[a-z0-9-]+\.)*r2\.dev(?=[/?#"'\\\s<>]|$)/gi;

/** Replace only the public R2 origin; preserve object bytes, escaping and query. */
export function publicImageUrl(value) {
  return typeof value === "string" ? value.replace(DEVELOPMENT_ORIGIN, PUBLIC_ASSET_ORIGIN) : value;
}

/** Build an image URL from a bucket key, or normalize an existing absolute URL. */
export function publicAssetUrl(key) {
  if (/^(?:https?:)?\/\//i.test(key)) return publicImageUrl(key);
  return `${PUBLIC_ASSET_ORIGIN}/${key.replace(/^\/+/, "")}`;
}

/** Non-mutating normalization for JSON payloads and SSR bootstrap snapshots. */
export function normalizePublicImageUrls(value) {
  if (typeof value === "string") return publicImageUrl(value);
  if (Array.isArray(value)) return value.map(normalizePublicImageUrls);
  if (value && typeof value === "object" &&
      (Object.getPrototypeOf(value) === Object.prototype || Object.getPrototypeOf(value) === null)) {
    return Object.fromEntries(Object.entries(value).map(([key, item]) => [key, normalizePublicImageUrls(item)]));
  }
  return value;
}
